import React from 'react';
import styles from './ContractHeader.module.scss';

const ContractHeader = ({
    contractTitle,
    isDraft = false,
    /** When set ('DRAFT' | 'ACTIVE'), shows exact lifecycle badge; falls back to isDraft for Draft only. */
    contractLifecycleStatus,
    contractSubtitle,
    contractId,
    alerts = [],
    lastUpdated,
    lastUpdatedBy,
    alertIcon,
    alertIcons = []
}) => {
    const lifecycleUpper = contractLifecycleStatus
        ? String(contractLifecycleStatus).trim().toUpperCase()
        : null;

    const renderLifecycleBadge = () => {
        if (lifecycleUpper === 'ACTIVE') {
            return <span className={styles.draftLabel}> - Active</span>;
        }
        if (lifecycleUpper === 'DRAFT' || isDraft) {
            return <span className={styles.draftLabel}> - Draft</span>;
        }
        return null;
    };

    return (
        <div className={styles.headerContainer}>
            <div className={styles.headerLeft}>
                <div className={styles.headerTitleRow}>
                    <span className={styles.contractMainTitle}>
                        {contractTitle}{renderLifecycleBadge()}
                    </span>
                </div>
                <div className={styles.contractSubtitle}>Contract ID : {contractId}</div>
            </div>

            {/* <div className={styles.headerRight}>
                <div className={styles.alertColumn}>
                    {alerts.map((alert, index) => (
                        <div key={index} className={styles.statusAlert}>
                            <img
                                src={alertIcons[index] || alertIcon}
                                alt="Alert"
                                className={styles.alertIcon}
                            />
                            <span className={styles.statusAlertText}>{alert}</span>
                        </div>
                    ))}
                </div>
                <div className={styles.headerRight1}>
                {alerts.map((alert, index) => (
                    <div className={styles.statusAlert}>
                        <span className={styles.statusAlertText}>
                            Last Updated: {lastUpdated}
                            {lastUpdatedBy && <span className={styles.statusAlertText}>, By {lastUpdatedBy}</span>}
                        </span>
                    </div>
                ))}
                <div className={styles.contractIdRight}>Contract ID: {contractId}</div>
            </div>
            </div> */}
            <div className={styles.headerRight}>
    <div className={styles.alertColumn}>
        {alerts.map((alert, index) => (
            <div key={index} className={styles.statusAlert}>
                <img
                    src={alertIcons[index] || alertIcon}
                    alt="Alert"
                    className={styles.alertIcon}
                />
                <span className={styles.statusAlertText}>
                    {alert} and Last Updated on {lastUpdated}
                    {lastUpdatedBy && ` By ${lastUpdatedBy}`}
                </span>
            </div>
        ))}
    </div>

    <div className={styles.contractSubtitle}>
        {contractSubtitle}{renderLifecycleBadge()}
    </div>
</div>
        </div>
    );
};

export default ContractHeader;
